import { render, staticRenderFns } from "./systemManagement.vue?vue&type=template&id=235964ff&scoped=true&"
import script from "./systemManagement.vue?vue&type=script&lang=js&"
export * from "./systemManagement.vue?vue&type=script&lang=js&"
import style0 from "./systemManagement.vue?vue&type=style&index=0&id=235964ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235964ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VFlex,VLayout,VTab,VTabItem,VTabs,VTabsItems})
